import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
// import reportWebVitals from './reportWebVitals';
import GlobalStyles from './Components/GlobalStyles';
import { PersistGate } from 'redux-persist/integration/react';
import ToastMessage from "../src/Components/ToastMessage";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <GlobalStyles>
        <App />
        <ToastMessage/>
      </GlobalStyles>
    </PersistGate>
  </Provider >
);
